import type { SxStyle } from '@aibees/shared/theme';

export const table: SxStyle = {
  backgroundColor: (p) => p.palette.common.white,
  border: '1px solid',
  borderColor: 'divider',
};

export const headerFeatureCell: SxStyle = {
  verticalAlign: 'top',
  borderRight: '1px solid',
  borderBottom: '1px solid',
  borderColor: 'divider',
  minWidth: (p) => p.spacing(30),
  p: 3,
  height: '1px',
};

export const divider: SxStyle = {
  mb: 1.5,
};

export const comparePlansCell: SxStyle = {
  height: '100%',
  justifyContent: 'space-between',
};

export const headerPlanCell: SxStyle = {
  verticalAlign: 'top',
  borderRight: '1px solid',
  borderBottom: '1px solid',
  borderColor: 'divider',
  p: 0,
  width: 269,
  minWidth: 269,
  '&:last-of-type': { borderRight: 0 },
};

export const featureRow: SxStyle = {};

export const topRowFeatureCell: SxStyle = {
  pl: 5,
  pr: 1,
  py: 1.5,
  borderRight: '1px solid',
  borderBottom: '1px solid',
  borderColor: 'divider',
  minWidth: (p) => p.spacing(35),
};

export const featureValueCell: SxStyle = {
  borderRight: '1px solid',
  borderBottom: '1px solid',
  borderColor: 'divider',
  width: 269,
  minWidth: 269,
  '&:last-of-type': { borderRight: 0 },
};
